import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CreatePulseDialogComponent } from "src/app/pages/kepler/pulse/create-pulse-dialog/create-pulse-dialog.component";
import { SurveyService } from "../../services/survey.service";
import { DeletePopupComponent } from "../delete-popup/delete-popup.component";
import { ToastrService } from "ngx-toastr";
import { FinancialService } from "../../services/financial.service";
import { ProjectService } from "../../services/project.service";
import { RiskConvergenceService } from "../../services/risk-convergence.service";
import { MessageService } from "../../services/message.service";
import textConfiguration from "src/assets/static-text-configuration.json";

@Component({
  selector: "app-pulse",
  templateUrl: "./pulse.component.html",
  styleUrls: ["./pulse.component.scss"],
})
export class PulseComponent implements OnInit {
  @Input() pulsesList: any = null;
  @Input() projectId: any = null;
  @Input() card: any = null;
  @Input() isRisk: any = false;
  @Input() qParams: any;
  @Input() activeTab: number = 0;
  @Input() showPreprocessed: boolean = true;
  @Output() pulseRefresh = new EventEmitter<number>();
  commonText: any = (textConfiguration as any).common;

  constructor(
    private readonly dialog: MatDialog,
    private readonly surveyService: SurveyService,
    private readonly toastrService: ToastrService,
    private readonly financialService: FinancialService,
    private readonly projectService: ProjectService,
    private readonly riskConvergenceService: RiskConvergenceService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    let descList = this.pulsesList.map((pulse: any) => pulse?.description);
    this.messageService.setGnews({
      pagename: "Hubble - Pulse page",
      queryParam: { pulse_desc: JSON.stringify(descList) },
    });
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 50%, 25%, 90%)`;
  }

  getPerformanceImpact(pulse: any) {
    let perfImpact = "";
    pulse.performance_impact.forEach((impact: any) => {
      perfImpact += impact.display_name + ", ";
    });
    perfImpact = perfImpact.trimEnd();
    if (perfImpact.endsWith(",")) {
      perfImpact = perfImpact.slice(0, -1);
    }
    return perfImpact;
  }

  getPulse(id?: number) {
    let pulseService;

    if (this.projectId) {
      pulseService = this.financialService.getProjectPulse(this.projectId);
    } else if (this.card) {
      const qParam = `performance_impact=${this.card}`;
      pulseService = this.projectService.getCardPulse(qParam);
    } else if (this.isRisk) {
      pulseService = this.riskConvergenceService.getRiskPulse();
    } else {
      this.pulseRefresh.emit(id);
    }
    if (pulseService) {
      pulseService.subscribe((res: any) => {
        this.pulsesList = (res || []).map((pulse: any) => ({
          ...pulse,
          color: this.getGMapRandomColor(),
          impact: this.getPerformanceImpact(pulse),
        }));
      });
    }
  }

  getPulsesByStatus(status: string) {
    if (!this.pulsesList) return [];
    return this.pulsesList.filter((pulse: any) => pulse.status === status);
  }
  getPositivePulses() {
    if (!this.pulsesList) return [];
    return this.pulsesList.filter(
      (pulse: any) => pulse.status === "processed" && pulse.is_positive
    );
  }

  getNegativePulses() {
    if (!this.pulsesList) return [];
    return this.pulsesList.filter(
      (pulse: any) => pulse.status === "processed" && !pulse.is_positive
    );
  }

  deletePulse(id: any, name: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: name,
      autoFocus: false,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.surveyService.deletePulse(id).subscribe(() => {
          this.toastrService.success("Pulse deleted successfully");
          this.getPulse(id);
        });
      }
    });
  }

  showEditPulseDialog(pulse: any) {
    const dialog = this.dialog.open(CreatePulseDialogComponent, {
      width: "50vw",
      maxHeight: "80vh",
      minHeight: "63vh",
      disableClose: true,
      autoFocus: false,
      data: {
        pulseId: pulse.id,
      },
    });
    dialog.afterClosed().subscribe((data: any) => {
      if (data) {
        this.getPulse();
      }
    });
  }
}
